

export class AssetChecklistRequestDto {
    assetServeId: number;

    constructor(assetServeId: number){
        this.assetServeId = assetServeId;
    }
}